'use strict';
var global = require('../internals/global');

module.exports = global.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/internals/promise-native-constructor.js
// module id = zHoh
// module chunks = 0